import { render, staticRenderFns } from "./IvyCodeGen.vue?vue&type=template&id=f02872b8&"
import script from "./IvyCodeGen.vue?vue&type=script&lang=js&"
export * from "./IvyCodeGen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports